import type { HttpClient } from '../http/HttpClient'
import { backendStatus } from '../http/errorDetail'
import type { BudgetRepository, BudgetUse } from '@/domain/home/Budget'

interface RawBudgetGroup {
  group_id: string
  period_label: string | null
  dimensions: Record<string, { name: string }>
  custom_dimensions: { name: string }[]
  used_rep: string
  total_rep: string
  percentage: number
  exceeded: boolean
}

export class HttpBudgetRepository implements BudgetRepository {
  constructor(private readonly http: HttpClient) {}

  async mostUsed(activeOn: string, limit: number): Promise<BudgetUse[]> {
    let raw: { results: RawBudgetGroup[] }
    try {
      raw = await this.http
        .url('budgets')
        .params({ active_on: activeOn, ordering: '-usage', page_size: String(limit) })
        .get<{ results: RawBudgetGroup[] }>()
    } catch (error) {
      if (backendStatus(error) === 404) return []
      throw error
    }
    return raw.results.map((group) => ({
      id: group.group_id,
      name: [...Object.values(group.dimensions).map((d) => d.name), ...group.custom_dimensions.map((d) => d.name)].join(' · ') || (group.period_label ?? ''),
      used: group.used_rep,
      total: group.total_rep,
      percentage: group.percentage,
      exceeded: group.exceeded,
    }))
  }
}
